import { Pipe, PipeTransform } from '@angular/core';
import {CommonModule} from "@angular/common";
const vanillaMasker = require('vanilla-masker');

@Pipe({
    name: 'cpfCnpj',
    standalone: false
})
export class CpfCnpjPipe implements PipeTransform {
    transform(value: any) {
        const cpfPattern = '999.999.999-99';
        const cnpjPattern = 'SS.SSS.SSS/SSSS-SS';

        if (!value) {
            return '';
        }

        if (value.length > 11) {
            return vanillaMasker.toPattern(value, cnpjPattern);
          }

        return vanillaMasker.toPattern(value, cpfPattern);
    }
}


